import { ApplicationService } from '~/services/core/application.service'

export class TrackerService extends ApplicationService {
  get baseUrl () {
    return this.runtimeConfig.BASE_API_URL
  }

  private readonly facebookEventActionSource = 'website'

  pushFacebookEvent (payload: any): Promise<any> {
    return this.post('/api/trackers/facebook/', payload)
  }
}
